"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const Client_1 = __importDefault(require("./Client"));
const Product_1 = __importDefault(require("./Product"));
const Project_1 = __importDefault(require("./Project"));
const QR_1 = __importDefault(require("./QR"));
const Crop_1 = __importDefault(require("./Crop"));
const Category_1 = __importDefault(require("./Category"));
const trans_1 = require("@common/tsutils/trans");
const emptyData = {
    client: {
        name: '',
        address1: '',
        address2: '',
    },
    product: {
        name: '',
        treatment: '',
        type: '',
    },
    project: {
        name: '',
        date: '',
        locationsCount: 0,
        scope: '',
    },
    crop: [],
    categories: [],
    qr: {
        url: '',
        code: '',
    },
    isPublished: false,
};
class Summary {
    constructor(data = emptyData) {
        this.client = new Client_1.default(data.client) || new Client_1.default();
        this.product = new Product_1.default(data.product) || new Product_1.default();
        this.project = new Project_1.default(data.project) || new Project_1.default();
        this.crop = data.crop.map((crop) => new Crop_1.default(crop)) || [];
        this.categories =
            data.categories.map((category) => new Category_1.default(category)) || [];
        this.qr = new QR_1.default(data.qr) || new QR_1.default();
        this.isPublished = data.isPublished || false;
    }
    getYear(s) {
        if (s === '-') {
            return '-';
        }
        else {
            const date = new Date(s);
            return date.getFullYear().toString();
        }
    }
    get effCategories() {
        return this.categories.filter((category) => category.dimension === 'efficacy' && category.metrics.length > 0);
    }
    get bioCategories() {
        return this.categories.filter((category) => category.dimension === 'biodiversity' && category.metrics.length > 0);
    }
    get generalFeaturesCards() {
        const hooks = [
            (0, trans_1.trans)('trialsSummaryPublic.cards.type'),
            (0, trans_1.trans)('trialsSummaryPublic.cards.name'),
            (0, trans_1.trans)('trialsSummaryPublic.cards.year'),
            (0, trans_1.trans)('trialsSummaryPublic.cards.locs'),
            (0, trans_1.trans)('trialsSummaryPublic.cards.scope'),
        ];
        const cardsModel = [];
        hooks.forEach((cardTitle) => {
            if (cardTitle === (0, trans_1.trans)('trialsSummaryPublic.cards.type')) {
                cardsModel.push({ title: cardTitle, sub: this.product.type });
            }
            if (cardTitle === (0, trans_1.trans)('trialsSummaryPublic.cards.name')) {
                cardsModel.push({ title: cardTitle, sub: this.project.name });
            }
            if (cardTitle === (0, trans_1.trans)('trialsSummaryPublic.cards.year')) {
                cardsModel.push({
                    title: cardTitle,
                    sub: this.getYear(this.project.date),
                });
            }
            if (cardTitle === (0, trans_1.trans)('trialsSummaryPublic.cards.locs')) {
                cardsModel.push({
                    title: this.project.locationsCount === 1
                        ? (0, trans_1.trans)('trialsSummaryPublic.instans_s')
                        : (0, trans_1.trans)('trialsSummaryPublic.instans'),
                    sub: this.project.locationsCount.toString(),
                });
            }
            if (cardTitle === (0, trans_1.trans)('trialsSummaryPublic.cards.scope')) {
                cardsModel.push({ title: cardTitle, sub: this.project.scope });
            }
        });
        return cardsModel;
    }
}
exports.default = Summary;
